// extracted by mini-css-extract-plugin
export default {"fade":"XOAmefijo9ldjfq_v8G0","fadeIn":"obyMTQBY5VsXypkQ72vf","fadeOut":"ruBKynVjSlCCBEt7j6w_"};